import React, { useEffect, useState } from "react";
import axios from "../services/tmdb";
import "./MovieModal.css";

function MovieModal({ movie, onClose }) {
  const [seasons, setSeasons] = useState([]);
  const [selectedSeason, setSelectedSeason] = useState(1);
  const [selectedEpisode, setSelectedEpisode] = useState(1);
  const [loading, setLoading] = useState(true);

  // Lógica para identificar se é série ou filme (essencial para o Banner)
  // Séries no TMDB usam 'first_air_date', filmes usam 'release_date'
  const isMovie = movie.release_date ? true : false;

  useEffect(() => {
    async function fetchSeriesDetails() {
      if (!isMovie) {
        try {
          setLoading(true);
          // Busca os detalhes da série para obter a lista real de temporadas
          const response = await axios.get(
            `/tv/${movie.id}?api_key=05718740b6369f535c8c07057816e165&language=pt-BR`
          );
          // Filtra a "Temporada 0" (especiais) se desejar
          const filteredSeasons = response.data.seasons.filter(
            (s) => s.season_number > 0
          );
          setSeasons(filteredSeasons);
          setLoading(false);
        } catch (error) {
          console.error("Erro ao carregar detalhes da série:", error);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    }
    fetchSeriesDetails();
  }, [movie, isMovie]);

  // URLs da API conforme sua documentação (Vidsrc)
  const streamUrl = isMovie
    ? `https://vidsrc.to/embed/movie/${movie.id}`
    : `https://vidsrc.to/embed/tv/${movie.id}/${selectedSeason}/${selectedEpisode}`;

  return (
    <div className="modal__backdrop" onClick={onClose}>
      <div className="modal__container" onClick={(e) => e.stopPropagation()}>
        <button className="modal__close" onClick={onClose}>✕</button>
        
        <div className="modal__video">
          <iframe
            title="player"
            src={streamUrl}
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen
            allow="autoplay; encrypted-media"
          ></iframe>
        </div>

        <div className="modal__content">
          <h1 className="modal__title">
            {movie.title || movie.name || movie.original_name}
          </h1>
          
          {/* Aba de Seleção: Só aparece se NÃO for filme e houver temporadas */}
          {!isMovie && !loading && (
            <div className="modal__navigation">
              <div className="nav__item">
                <label>Temporada</label>
                <select 
                  value={selectedSeason} 
                  onChange={(e) => {
                    setSelectedSeason(e.target.value);
                    setSelectedEpisode(1); // Reseta para o episódio 1 ao trocar temporada
                  }}
                >
                  {seasons.map((s) => (
                    <option key={s.id} value={s.season_number}>
                      {s.name || `Temporada ${s.season_number}`}
                    </option>
                  ))}
                </select>
              </div>

              <div className="nav__item">
                <label>Episódio</label>
                <input 
                  type="number" 
                  min="1" 
                  value={selectedEpisode} 
                  onChange={(e) => setSelectedEpisode(e.target.value)}
                />
              </div>
            </div>
          )}

          <p className="modal__overview">
            {movie.overview || "Nenhuma descrição disponível."}
          </p>
          
          <div className="modal__footer">
            <span className="modal__rating">Avaliação: {movie.vote_average?.toFixed(1)}</span>
            <span className="modal__date">{movie.release_date || movie.first_air_date}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MovieModal;
